import { render, staticRenderFns } from "./ModalPermisosFolder.vue?vue&type=template&id=908e7102"
import script from "./ModalPermisosFolder.vue?vue&type=script&lang=js"
export * from "./ModalPermisosFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('908e7102')) {
      api.createRecord('908e7102', component.options)
    } else {
      api.reload('908e7102', component.options)
    }
    module.hot.accept("./ModalPermisosFolder.vue?vue&type=template&id=908e7102", function () {
      api.rerender('908e7102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/ModalPermisosFolder.vue"
export default component.exports